import { render, staticRenderFns } from "./StandardBars.vue?vue&type=template&id=aeb5da38"
import script from "./StandardBars.vue?vue&type=script&lang=js"
export * from "./StandardBars.vue?vue&type=script&lang=js"
import style0 from "./StandardBars.vue?vue&type=style&index=0&id=aeb5da38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports